import { useState } from "react";

import { Grid2, Typography, Modal, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AddButton from "../themes/overrides/AddButton";
import ModalBox from "../themes/overrides/ModalBox";
import cancelIcon from "../assets/images/redo.svg";
import PropTypes from 'prop-types';
import InstallButton from "../themes/overrides/InstallButton";

const AppInstallModal = ({
    open,
    onClose,
    text,
    onConfirm,
    startIcon = null,
    deleteButtonLabel,
    workspaces,
    selectedWorkspace,
    onWorkspaceChange,
    selectedAppId
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [error, setError] = useState();

    const handleConfirm = () => {
        if (selectedWorkspace === null) {
            console.log('WORKSPACES : ', workspaces);
            
            setError('Select a workspace');
            return;
        }
        onConfirm();
    }

    return (
        <Modal open={open} onClose={onClose}>
            <ModalBox sx={{ width: '520px', maxWidth: '95%' }}>
                <Typography variant="h2" sx={{ mb: 1 }}>
                    Install App
                </Typography>
                <Grid2>
                    <Typography>
                        <span>{text}</span>
                    </Typography>

                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel
                            sx={{
                                fontSize: "1rem",
                                color: "gray",
                            }}
                        >
                            Select Workspace
                        </InputLabel>
                        <Select
                            value={selectedWorkspace || ''}
                            onChange={onWorkspaceChange}
                            label="Select Workspace"
                            sx={{
                                fontSize: "1.1rem",
                                color: "#333",
                            }}
                        >
                            {workspaces?.length > 0 ? (
                                workspaces?.map((workspace) => (
                                    <MenuItem
                                        key={workspace._id}
                                        value={workspace._id}
                                        disabled={workspace.apps?.includes(selectedAppId)}
                                        sx={{
                                            fontSize: "1.1rem",
                                        }}
                                    >
                                        {workspace.name}
                                        {workspace.apps?.includes(selectedAppId) && 
                                        " (Already app installed)"}
                                    </MenuItem>
                                ))
                            ) : (
                                <MenuItem disabled>
                                    <Typography
                                        sx={{
                                            fontSize: "1.1rem",
                                            color: "gray",
                                        }}
                                    >
                                        No Workspaces
                                    </Typography>
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    
                    <Typography
                        variant="caption"
                        color="error"
                        sx={{
                            display: 'block',
                            mt: 0.5,
                            ml: 1
                        }}
                    >
                        {error}
                    </Typography>

                    <Grid2 sx={{
                        mt: 4,
                        display: 'flex',
                        flexDirection: {
                            xs: 'column',
                            md: 'row',
                        },
                        justifyContent: 'space-between'
                    }}>
                        <AddButton
                            startIcon={
                                <img
                                    src={cancelIcon}
                                    alt="Cancel Icon"
                                    style={{ width: 24, height: 24 }}
                                />
                            }
                            label="Cancel"
                            sx={{ fontSize: '16px', width: { xs: '100%', md: '150px' } }}
                            onClick={onClose}
                        />
                        <InstallButton
                            startIcon={startIcon}
                            label={deleteButtonLabel}
                            sx={{ fontSize: '16px', color: "#105b2b", border: "1.5px solid", width: { xs: '100%', md: '150px' }, mt: isMobile && 1 }}
                            onClick={handleConfirm}
                        />
                    </Grid2>
                </Grid2>
            </ModalBox>
        </Modal>
    );
};

AppInstallModal.propTypes = {
    open: PropTypes.any,
    onClose: PropTypes.func,
    text: PropTypes.string,
    onConfirm: PropTypes.func,
    startIcon: PropTypes.any,
    deleteButtonLabel: PropTypes.string,
    selectedAppId: PropTypes.string
};

export default AppInstallModal;